import { StatsScreen } from '../pages/stats_profile/lib/ctx/stats_manage/types'
import { isAndroid } from './url'

export const sendToNative = ({
  id,
  payload,
}: {
  id?: string
  payload: Record<string, unknown>
}) => {
  const eventId = id || 'web_to_native'
  const device = isAndroid ? 'android' : 'ios'
  const handler = window.webkit?.messageHandlers?.fablenative
  const namespace = `[${device}][${eventId}]`
  const payloadString = JSON.stringify(payload)

  console.info(`${namespace} sending payload to native:\n${payloadString}`)

  if (!handler) {
    console.error(`${namespace} fablenative handler not found`)
    return
  }

  let msgPayload: Record<string, unknown> | string

  if (isAndroid) {
    msgPayload = payloadString
  } else {
    msgPayload = payload
  }

  handler.postMessage(msgPayload)

  console.info(`${namespace} payload sent`)
}

export const closeWebView = () => {
  sendToNative({
    payload: {
      type: 'web_event',
      body: {
        action: 'close_web_view',
      },
    },
  })
}

export type NativeHapticOneShotType =
  | 'light'
  | 'medium'
  | 'heavy'
  | 'success'
  | 'error'
  | 'warning'
  | 'selection_changed'

export const sendHapticOneShot = (type: NativeHapticOneShotType) => {
  sendToNative({
    id: 'haptic_event',
    payload: {
      type: 'haptic',
      body: { haptic_type: type },
    },
  })
}

const openCurrentlyReading = () => {
  sendToNative({
    id: 'open_currently_reading',
    payload: {
      type: 'deep_link',
      body: {
        url: 'https://fable.co/app/book-list/current_reading',
      },
    },
  })
}

const openFinishedList = () => {
  sendToNative({
    id: 'open_finished_list',
    payload: {
      type: 'deep_link',
      body: {
        url: 'https://fable.co/app/book-list/finished',
      },
    },
  })
}

const openStreaksManagement = () => {
  sendToNative({
    id: 'open_streaks_management',
    payload: {
      type: 'deep_link',
      body: {
        url: 'https://fable.co/app/streak_management',
      },
    },
  })
}

const openBookDetail = (id: string) => {
  sendToNative({
    id: 'open_book_detail',
    payload: {
      type: 'deep_link',
      body: {
        url: `https://fable.co/app/book/${id}`,
      },
    },
  })
}

const openReviewDetail = (id: string) => {
  sendToNative({
    id: 'open_review_detail',
    payload: {
      type: 'deep_link',
      body: {
        url: `https://fable.co/app/reviews/${id}`,
      },
    },
  })
}

const openUserProfile = (id: string) => {
  sendToNative({
    id: 'open_user_profile',
    payload: {
      type: 'deep_link',
      body: {
        url: `https://fable.co/app/users/${id}`,
      },
    },
  })
}

const openGoodreadsImporter = () => {
  sendToNative({
    id: 'open_goodreads_importer',
    payload: {
      type: 'deep_link',
      body: {
        url: `https://fable.co/app/goodreads_importer`,
      },
    },
  })
}

const openGroupChats = () => {
  sendToNative({
    id: 'open_group_chat',
    payload: {
      type: 'deep_link',
      body: {
        url: `https://fable.co/app/group_chats`,
      },
    },
  })
}

const openStatsEditMode = (tab: StatsScreen) => {
  sendToNative({
    id: 'open_stats_edit_mode',
    payload: { type: 'open_stats_edit', body: { tab } },
  })
}

const closeStatsEditMode = () => {
  sendToNative({
    id: 'close_stats_edit_mode',
    payload: { type: 'close_stats_edit' },
  })
}

export const native = {
  events: {
    send: sendToNative,
    sendHapticOneShot,
    closeWebView,
    openCurrentlyReading,
    openFinishedList,
    openStreaksManagement,
    openBookDetail,
    openReviewDetail,
    openUserProfile,
    openGoodreadsImporter,
    openGroupChats,
    openStatsEditMode,
    closeStatsEditMode,
  },
}
